import type { Gate } from '@/lib/contract';
import { cn } from '@/lib/cn';

const GATE_CLASS: Record<'pass' | 'cond' | 'fail', string> = {
  pass: 'text-pass',
  cond: 'text-warn',
  fail: 'text-danger'
};

/** PASS / COND / FAIL, or an em dash when the gate has not been decided. */
export function GateBadge({ gate, className }: { gate: Gate; className?: string }) {
  if (!gate) return <span className={cn('text-dim', className)}>—</span>;
  return (
    <span className={cn('font-mono text-[11px] tracking-[0.12em] uppercase', GATE_CLASS[gate], className)}>{gate}</span>
  );
}
